import { getCliengoClient } from '@cliengo/mfe-utils/mod';
import { KORI_URL } from '@/constants/whatsapp-cloud';

export interface OnboardWhatsappCloudBody {
  code: string;
  wabaId: string;
  phoneNumberId: string;
  pin?: string;
}

export interface OnboardWhatsappCloudResponse {
  channelId: string;
  phoneNumberId: string;
  wabaId: string;
  whatsappNumber: string;
  connected: boolean;
}

/** kori hace el canje del code, el registro del número y la suscripción a la WABA. */
export const onboardWhatsappCloud = async (
  channelId: string,
  body: OnboardWhatsappCloudBody,
): Promise<OnboardWhatsappCloudResponse> => {
  const client = getCliengoClient({ baseUrl: `${KORI_URL}/1.0` });
  const { data } = await client.post<OnboardWhatsappCloudResponse>(
    `/channels/${channelId}/whatsapp-cloud/onboard`,
    body,
  );
  return data;
};
